<div>
    <div class="col-md-12">
        <h3 class="float-right mr-3">GEOLOCATION MAP</h3>
        <br>
    </div>
</div>
<div class="p-0">
    <div id="map"></div>
</div>